module.exports = __webpack_public_path__ + "img/xuexiao_logo.02d017cb.png";